document.addEventListener('DOMContentLoaded', function() {
  const accordionButtons = document.querySelectorAll('.product-faq__accordion-button');

  function toggleAccordion(event) {
    const button = event.target; // The button that was clicked
    const expanded = button.getAttribute('aria-expanded') === 'true';
    const control = document.getElementById(button.getAttribute('aria-controls'));

    button.setAttribute('aria-expanded', !expanded);

    if (!expanded) {
      control.style.display = 'block';
    } else {
      control.style.display = 'none';
    }
  }

  accordionButtons.forEach(function(button) {
    button.addEventListener('click', toggleAccordion);
  });
});
